import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ChatExploreRail } from '../components/ChatView/ChatExploreRail';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { useLayoutStore } from '../lib/stores/LayoutStore';
// Shell for /assistant/* routes: a persistent left explore rail alongside the
// chat content (landing composer or a conversation). The outer chrome
// (global sidebar, header) comes from DashboardLayout above it. Owns the
// breadcrumb-hiding that Assistant/Chat each used to do individually.
export function AssistantLayout() {
    const isNarrow = useMediaQuery('(max-width: 767px)');
    const location = useLocation();
    const setChatRailCollapsed = useLayoutStore((state)=>state.setChatRailCollapsed);
    const setShowBreadcrumbs = useLayoutStore((state)=>state.setShowBreadcrumbs);
    const setShowHeader = useLayoutStore((state)=>state.setShowHeader);
    const chatRailCollapsed = useLayoutStore((state)=>state.chatRailCollapsed);
    // The chat owns its own header row (title + chip + actions), so the shell's
    // generic metadata band — "Assistant / Converse with the AI" — is redundant
    // chrome stacked above it, and it ate the vertical space the thread wants.
    useEffect(()=>{
        setShowBreadcrumbs(false);
        setShowHeader(false);
        return ()=>{
            setShowBreadcrumbs(true);
            setShowHeader(true);
        };
    }, [
        setShowBreadcrumbs,
        setShowHeader
    ]);
    useEffect(()=>{
        if (isNarrow && location.pathname) setChatRailCollapsed(true);
    }, [
        isNarrow,
        location.pathname,
        setChatRailCollapsed
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-full min-h-0 flex-col",
        children: [
            isNarrow && /*#__PURE__*/ _jsx("div", {
                className: "border-b border-border px-2 py-1",
                children: /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "ghost",
                    size: "sm",
                    "aria-expanded": !chatRailCollapsed,
                    onClick: ()=>setChatRailCollapsed(!chatRailCollapsed),
                    children: chatRailCollapsed ? 'Chat history' : 'Close chat history'
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "relative flex min-h-0 flex-1",
                children: [
                    !chatRailCollapsed && /*#__PURE__*/ _jsx("div", {
                        className: isNarrow ? 'absolute inset-y-0 left-0 z-40 shadow-lg' : 'flex',
                        children: /*#__PURE__*/ _jsx(ChatExploreRail, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex min-w-0 flex-1 flex-col",
                        children: /*#__PURE__*/ _jsx(Outlet, {})
                    })
                ]
            })
        ]
    });
}
